import i18n from 'i18next'

type UnitLabels = { y: string; d: string; h: string; m: string; s: string }

const LABELS: Record<'en' | 'ar', UnitLabels> = {
	en: { y: 'y', d: 'd', h: 'h', m: 'm', s: 's' },
	ar: { y: 'سنة', d: 'يوم', h: 'س', m: 'د', s: 'ث' },
}

/**
 * Shared learning-time formatter: the top two nonzero units ("2h 15m"),
 * seconds only when the total is under a minute (so short times render
 * "45s", never "0"). Unit labels follow the active i18next language.
 */
export const formatDuration = (totalSeconds: number): string => {
	const seconds = Math.max(0, Math.floor(Number(totalSeconds) || 0))
	const lang: 'en' | 'ar' = (i18n.language || 'en').startsWith('ar') ? 'ar' : 'en'
	const labels = LABELS[lang]
	if (seconds === 0) return '0'
	if (seconds < 60) return `${seconds}${labels.s}`
	const units = [
		{ label: labels.y, secs: 31536000 },
		{ label: labels.d, secs: 86400 },
		{ label: labels.h, secs: 3600 },
		{ label: labels.m, secs: 60 },
	]
	const parts: string[] = []
	let rest = seconds
	for (const unit of units) {
		const value = Math.floor(rest / unit.secs)
		if (value > 0) {
			parts.push(`${value}${unit.label}`)
			rest %= unit.secs
		}
		if (parts.length === 2) break
	}
	return parts.join(' ')
}

export default formatDuration
